<div class="menu-nav" appScrollList *ngIf="{activeCategoryIndex: activeCategoryIndex$ | async} as data" [activeIndex]="data.activeCategoryIndex!">
  <div class="menu-nav__toggle">
    <button class="menu-nav__button button button--th-second" (click)="isShowModal = true">
      <mat-icon class="material-icons">drag_handle</mat-icon>
    </button>
  </div>

  <div class="menu-nav__inner">

    <div class="menu-nav__scroller">
      <div class="menu-nav__item" *ngFor="let item of menuGroups; let i = index">
        <button
          appScrollButton
          [routerLink]="'/category/' + item.slug"
          [class.is-active]="item.slug === (activeCategorySlug$ | async)"
          class="menu-nav__button button button--th-second"
          type="button"
          (click)="setActiveCategory(item.id, i)"
          [disabled]="item.isScheduleAvailable"
          [ngClass]="{'is-disable': item.isScheduleAvailable}"
        >
          {{ item.name }}
        </button>
      </div>
    </div>

    <button class="menu-nav__arrow _prev button-icon" [appScrollArrow]="'prev'"><mat-icon class="material-icons-outlined">navigate_before</mat-icon></button>
    <button class="menu-nav__arrow _next button-icon" [appScrollArrow]="'next'"><mat-icon class="material-icons-outlined">navigate_next</mat-icon></button>
  </div>
</div>

<div class="modal _mobile-full l-wrapper" *ngIf="isShowModal">
  <div class="modal__overlay" (click)="isShowModal = false"></div>
  <div class="modal__container">
    <div class="modal__close _pin">
      <button type="button" class="button-icon button-icon--th-main" (click)="onCloseModal()">
        <mat-icon class="material-icons-outlined">close</mat-icon>
      </button>
    </div>
    <div class="modal__content">
      <div class="modal__body l-wrapper">
        <div class="menu-nav-list">
          <div class="menu-nav-list__item" *ngFor="let item of menuGroups; let i = index">
            <button
              class="menu-nav-list__button link"
              type="button"
              [routerLink]="'/category/' + item.slug"
              routerLinkActive="is-active"
              (click)="setActiveCategory(item.id, i)"
              [disabled]="item.isScheduleAvailable"
              [ngClass]="{'is-disable': item.isScheduleAvailable}"
            >
              {{ item.name }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
